module.exports = __webpack_public_path__ + "img/newSideShareLogo.0f71049c.svg";